import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import deCommon from '../locales/de/common.json';
import deAuth from '../locales/de/auth.json';
import enCommon from '../locales/en/common.json';
import enAuth from '../locales/en/auth.json';

const resources = {
  de: {
    common: deCommon,
    auth: deAuth,
  },
  en: {
    common: enCommon,
    auth: enAuth,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    defaultNS: 'common',
    ns: ['common', 'auth'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
